import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  style: {
    "font-size": "16px"
  }
};
import router from '@/router';
import { AlarmClock, Trophy, User, Picture, Clock, Avatar, Collection, Folder, Shop, Flag, Document, DataAnalysis, List, Menu as IconMenu } from '@element-plus/icons-vue';
import { onMounted, ref } from 'vue';
import { useUserStore } from '@/store/user';
import { isBusinessRole } from '@/utils/roleAccess';
import { logout as logoutRequest } from '@/api/tc-server';
import pcRouter from '@/router/pcRouter';
export default /*@__PURE__*/_defineComponent({
  __name: 'indexPage',
  setup(__props) {
    const userStore = useUserStore(); // 获取用户信息
    const routePermissions = userStore.userInfo?.routePermissions?.split(',') || [];
    console.log(pcRouter[0].children);
    const pathMap = [{
      path: '/home/timed-task-management',
      name: '定时任务管理'
    }, {
      path: '/home/match-list',
      name: '比赛列表'
    }, {
      path: '/home/history-match-list',
      name: '竞彩历史比赛列表'
    }, {
      path: '/home/user-management',
      name: '用户管理'
    }, {
      path: '/home/role-list',
      name: '角色管理'
    }, {
      path: '/home/watermark',
      name: '添加水印'
    }, {
      path: '/home/store-management',
      name: '店铺管理'
    }, {
      path: '/home/team-roster',
      name: '球队阵容'
    }];
    // 根据路由路径返回对应图标组件
    function getMenuIcon(path) {
      const iconMap = {
        '/home/timed-task-management': AlarmClock,
        '/home/match-list': Trophy,
        '/home/user-management': User,
        '/home/account-logs': Document,
        '/home/watermark': Picture,
        '/home/dlt-poster': Picture,
        '/home/history-match-list': Clock,
        '/home/role-list': Avatar,
        '/home/dict-list': Collection,
        '/home/file-list': Folder,
        '/home/store-management': Shop,
        '/home/league-list': Flag,
        '/home/article-manage': Document,
        '/home/analytics-dashboard': DataAnalysis,
        '/home/team-roster': List
      };
      return iconMap[path] || IconMenu;
    }
    // 判断当前路径是否在routePermissions中
    function isPathInPermissions(path) {
      if (router.resolve(path).meta.requiresAdmin === true) return userStore.userInfo.roleInfo?.roleIdentifier === 'admin';
      if (router.resolve(path).meta.allowAdmin === true && userStore.userInfo.roleInfo?.roleIdentifier === 'admin') return true;
      if (router.resolve(path).meta.allowBusiness === true && isBusinessRole(userStore.userInfo.roleInfo?.roleIdentifier)) return true;
      return routePermissions.includes(path);
    }
    const userName = ref(userStore.userInfo.username);
    console.log(process.env.NODE_ENV);
    const handleOpen = (key, keyPath) => {
      console.log(key, keyPath);
    };
    const handleClose = (key, keyPath) => {
      console.log(key, keyPath);
    };
    const defActive = ref('');
    async function logout() {
      try {
        await logoutRequest({});
      } finally {
        userStore.clearToken();
      }
    }
    console.log(router.currentRoute.value.path);
    onMounted(() => {
      defActive.value = router.currentRoute.value.path;
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_alert = _resolveComponent("el-alert");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_footer = _resolveComponent("el-footer");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          style: {
            "display": "flex",
            "justify-content": "space-between",
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("div", {
            style: {
              "display": "flex",
              "font-size": "20px",
              "align-items": "end"
            }
          }, [_createElementVNode("span", null, "个人数据分析共享")], -1)), _createElementVNode("div", _hoisted_1, [_createTextVNode(" 欢迎用户：" + _toDisplayString(userName.value) + "！ ", 1), _createVNode(_component_el_button, {
            type: "text",
            onClick: logout
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("登出")])),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_el_container, {
          style: {
            "height": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: "200px",
            style: {
              "height": "calc(100vh - 60px)",
              "display": "flex",
              "flex-direction": "column",
              "justify-content": "space-between"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_menu, {
              router: "",
              "default-active": defActive.value,
              class: "el-menu-vertical-demo",
              onOpen: handleOpen,
              onClose: handleClose
            }, {
              default: _withCtx(() => [_createVNode(_component_el_alert, {
                title: "本平台非购彩平台，仅展示官方数据。",
                type: "warning",
                "show-icon": "",
                closable: false
              }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pcRouter)[0].children, item => {
                return _openBlock(), _createElementBlock(_Fragment, {
                  key: item.path
                }, [isPathInPermissions(item.path) ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: item.path
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(getMenuIcon(item.path))))]),
                    _: 2
                  }, 1024), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
                  _: 2
                }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
              }), 128))]),
              _: 1
            }, 8, ["default-active"]), _createElementVNode("div", null, [_cache[3] || (_cache[3] = _createElementVNode("div", {
              style: {
                "display": "flex",
                "justify-content": "center",
                "margin-top": "10px"
              }
            }, null, -1)), _createVNode(_component_el_footer, {
              style: {
                "text-align": "center",
                "padding": "10px",
                "border-top": "1px solid #ccc",
                "font-size": "12px",
                "margin-top": "20px"
              }
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("a", {
                href: "https://beian.miit.gov.cn/",
                target: "_blank",
                style: {
                  "color": "inherit",
                  "text-decoration": "none"
                }
              }, "蜀ICP备2025156980号-1", -1)])),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_main, {
            style: {
              "height": "calc(100vh - 60px)",
              "padding": "0"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
});